import axios from 'axios';

/**
 * 排班協調的 API 薄封裝。
 *
 * 所有寫入都是 POST 且帶 CSRF header —— /api 底下這組路由掛的是 web middleware，
 * 沒有 token 會被 419 擋掉。錯誤一律把後端的 message 丟出來給畫面顯示，
 * 後端訊息本來就是寫給員工看的（例如「該月份已由店長鎖定」）。
 */
const csrfToken = () =>
    (document.querySelector('meta[name="csrf-token"]') || {}).content || '';

const post = async (url, data) => {
    try {
        const res = await axios.post(url, data, {
            headers: { 'X-CSRF-TOKEN': csrfToken() },
        });
        return res.data;
    } catch (err) {
        const message =
            ((err.response || {}).data || {}).message || '操作失敗，請稍後再試';
        const error = new Error(message);
        error.status = (err.response || {}).status;
        throw error;
    }
};

export const fetchMonth = (year, month, manage) =>
    axios
        .get('/api/schedule-coordination/month', {
            params: { year, month, manage: manage ? 1 : 0 },
        })
        .then((res) => res.data);

export const setMark = (date, category, period) =>
    post('/api/schedule-coordination/mark', { date, category, period });

export const clearMark = (date) =>
    post('/api/schedule-coordination/unmark', { date });

export const setDone = (year, month, done) =>
    post('/api/schedule-coordination/done', { year, month, done: done ? 1 : 0 });

export const lockMonth = (year, month) =>
    post('/api/schedule-coordination/lock', { year, month });

export const unlockMonth = (year, month) =>
    post('/api/schedule-coordination/unlock', { year, month });

export const publishMonth = (year, month) =>
    post('/api/schedule-coordination/publish', { year, month });

/** 待協調排休：店長對一筆排休做決定（同意休假／維持上班，可一併調整時段） */
export const decideLeave = (userUuid, date, decision, period) =>
    post('/api/schedule-coordination/decide', {
        user_uuid: userUuid,
        date,
        decision,
        period: period || null,
    });

/** 取消一個協調決定，回到系統判定 */
export const clearDecision = (userUuid, date) =>
    post('/api/schedule-coordination/decide/clear', { user_uuid: userUuid, date });

/* ---------------- 例假日／休息日自動分類（店長端專用） ---------------- */

/** 重新分類：⛔ 只更新系統建議值，店長手動調過的格子不會被蓋掉 */
export const planDayTypes = (year, month) =>
    post('/api/schedule-coordination/day-types/plan', { year, month });

/** 店長逐格覆寫（理由非必填） */
export const overrideDayType = (userUuid, date, dayType, reason) =>
    post('/api/schedule-coordination/day-types/override', {
        user_uuid: userUuid,
        date,
        day_type: dayType,
        reason: reason || null,
    });

/** 一鍵回復系統建議 */
export const revertDayType = (userUuid, date) =>
    post('/api/schedule-coordination/day-types/revert', { user_uuid: userUuid, date });

/** 特殊事件只留標記，⛔ 不改日別、⛔ 系統不自動補休 */
export const markDayTypeHrReview = (userUuid, date, note) =>
    post('/api/schedule-coordination/day-types/hr-review', {
        user_uuid: userUuid,
        date,
        note: note || null,
    });
